import { ResponseError } from '~/utils';
import request from '../request';

export const getPublicAccessToken = async (): Promise<PublicTokenResponse> => {
  const { REACT_APP_CLIENT_ID, REACT_APP_CLIENT_SECRET } = process.env;
  try {
    const { data } = await request.post('/bank-services/security/auth/tokens', {
      grant_type: 'client_credentials',
      client_id: REACT_APP_CLIENT_ID,
      client_secret: REACT_APP_CLIENT_SECRET,
    });
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getPrivateAccessToken = async (
  id: string,
): Promise<TokenResponse> => {
  try {
    const { data } = await request.post('/credit-services/flows/loans/tokens', {
      id,
    });
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const fetchUserData = async (): Promise<UserData> => {
  const { data } = await request.get(`/bank-services/holders/me/accounts`);
  return data;
};

export const getTermsAndPolicy = async (): Promise<TermsAndPolicy> => {
  try {
    const { data } = await request.get('/bank-services/holders/me/terms');

    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getAddressByCEP = async (cep: string): Promise<AddressData> => {
  try {
    const { data } = await request.get(`/bank-services/ceps/${cep}`);
    return { ...data, foundAddress: true };
  } catch (error) {
    return {
      cep: `${cep.slice(0, 5)}-${cep.slice(5, 8)}`,
      city: '',
      neighborhood: '',
      street: '',
      uf: '',
      complement: '',
      number: '',
      foundAddress: false,
    };
  }
};

export const userImageValidation = async (
  payload: ImageValidationPayload,
): Promise<void> => {
  try {
    const { data } = await request.post(
      `/bank-services/holders/me/personal/account/documents`,
      payload,
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const updateCreditOnboardingUserAccount = async (
  payload: CreditOnboardingUserAccountPayload,
): Promise<void> => {
  try {
    const { data } = await request.patch(
      '/bank-services/holders/me/personal/account',
      payload,
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const acceptContract = async (): Promise<void> => {
  try {
    await request.post('/bank-services/holders/me/personal/account/credit', {});
  } catch (error) {
    throw new ResponseError(error);
  }
};
